import { orchestrator } from 'satcheljs';
import { onAvailableWidthBucketChanged } from '../actions/onAvailableWidthBucketChanged';
import { drawerPaneWidthChanged } from 'owa-drawer';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import calculateAvailableWidthBucket from '../utils/calculateAvailableWidthBucket';
import { updateFlexPaneInternalWidth } from '../utils/updateFlexPaneInternalWidth';
import { getAreDisplayAdsEnabled } from '../selectors/getAreDisplayAdsEnabled';
import { setBrowserWidthBucket } from '../actions/setAvailableHeightAndWidthBuckets';

orchestrator(drawerPaneWidthChanged, actionMessage => {
    const { paneId, targetWindow } = actionMessage;

    // Layout bucket system is main-window only.
    // Pop-out windows have their own simpler layout and don't participate in bucket calculations.
    const isMainWindow = targetWindow === window;

    if (isMainWindow) {
        const newAvailableWidthBucket = calculateAvailableWidthBucket(
            false /* skipCache */,
            getAreDisplayAdsEnabled(),
            true /* isShown — width only changes for visible panes */,
            paneId
        );
        setBrowserWidthBucket(newAvailableWidthBucket);
        onAvailableWidthBucketChanged(
            newAvailableWidthBucket,
            LayoutChangeSource.OwaSuiteHeaderFlexPaneExpandOrCollapse
        );
    }

    // CSS variable update is per-window — always run it
    updateFlexPaneInternalWidth(paneId, targetWindow);
});
